import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const url = "https://api.singledebt.in";

export const getTicketToken = createAsyncThunk(
  "ticket_token/getTicketToken",
  async () => {
    try {
      const res = await axios.get(`${url}/ticket_token`);
      return res.data.token[0].token;
    } catch (error) {
      throw error;
    }
  }
);

const ticketTokenSlice = createSlice({
  name: "ticket_token",
  initialState: {
    ticket_token: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTicketToken.fulfilled, (state, action) => {
        state.loading = false;
        state.ticket_token = action.payload;
      })
      .addCase(getTicketToken.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch token";
      });
  },
});

export default ticketTokenSlice.reducer;
